class AddNew extends React.Component {
    constructor(props) {
        super(props);
        function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                });
            return result;
        }
        let hide;
        let nothing;
        if(findGetParameter('f') === 'mina_osalen'){
            hide = true;
            if(this.props.item === 0){
                nothing= true;
            }
        } else{
            hide = false;
            nothing= false;
        }
        this.state = {
            hide:hide,
            nothing: nothing
        };
    };
    render(page=this.props.page) {
        let classType;
        let classText;
        if( page === "my_post" || page === "post") {
            classType = 'lisa_kuulutus';
            if(LANG['Lisa kuulutus']){
                classText = LANG['Lisa kuulutus']
            } else {
                classText = "Lisa kuulutus";
            }
        } else if( page === "my_auction" || page === "auction") {
            if(USER_ID > 0) {
                classType = 'lisa_oksjon';
            } else {
                classType = 'lisan_oksjoni';
            }

            if(LANG['Lisa oksjon']){
                classText = LANG['Lisa oksjon']
            } else {
                classText = "Lisa oksjon";
            }
        }
        if(!this.state.nothing){
            return (
                <React.Fragment>
                    <a href={`/index.php?f=${classType}`} className={`card addnew ${this.state.hide ? 'hide' : ''}`}>
                        <svg>
                            <use href="/symbol/svg/sprite.symbol.svg#big-auction-block-plus"></use>
                        </svg>
                        <span>
                         {classText}
                    </span>
                    </a>
                </React.Fragment>
            )
        } else{
            return (
                <React.Fragment>
                    <section className={'none-found'}>
                        <h2>{LANG['Oksjonid puuduvad'] || 'Oksjonid puuduvad'}</h2>
                    </section>
                </React.Fragment>
            )
        }

    }
}

export default AddNew;

